module.exports = __webpack_public_path__ + "img/_dsc8138.1be48ecc.jpg";